document.addEventListener('DOMContentLoaded', function() {
  const snizePage = document.querySelector('.snize-results-page');
  if (!snizePage) return;

  let resultsObserver = null;
  let resultsContainer = null;
  let isSorting = false;

  function movePaginationToTop() {
    const pages = [...document.querySelectorAll('.snize-page')].filter((page) => {
      const href = page.querySelector('a')?.getAttribute('href') || '';
      return /\/page/.test(href);
    });

    if (!pages.length) return;

    const parent = pages[0].parentElement;
    const needsReorder = pages.some((page, index) => parent.children[index] !== page);
    if (!needsReorder) return;

    isSorting = true;
    if (resultsObserver) resultsObserver.disconnect();

    // 倒序插入到最前，最终视觉顺序不变
    pages.reverse().forEach((page) => {
      parent.prepend(page);
    });

    requestAnimationFrame(() => {
      if (resultsObserver && resultsContainer) {
        resultsObserver.observe(resultsContainer, {
          childList: true,
          subtree: true,
        });
      }
      isSorting = false;
    });
  }

  let sortRaf = null;
  function scheduleMovePaginationToTop() {
    if (isSorting) return;
    if (sortRaf) cancelAnimationFrame(sortRaf);
    sortRaf = requestAnimationFrame(() => {
      sortRaf = null;
      movePaginationToTop();
    });
  }

  function repairPageImage(img) {
    if (!img || img.dataset.snizeImgRetried === '1') return;
    const item = img.closest('li.snize-page');
    const href = item && item.querySelector('a[href]')?.getAttribute('href');
    if (!href) return;
    img.dataset.snizeImgRetried = '1';
    fetch(href, { credentials: 'same-origin' })
      .then((response) => response.text())
      .then((html) => {
        const match = html.match(/property="og:image" content="([^"]+)"/);
        if (!match) return;
        let src = match[1].replace(/&amp;/g, '&');
        if (src.startsWith('//')) src = 'https:' + src;
        else if (src.startsWith('/')) src = window.location.origin + src;
        if (src && src !== img.src) img.src = src;
      })
      .catch(() => {});
  }

  function watchPageImages(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('li.snize-page img').forEach((img) => {
      if (img.dataset.snizeImgWatch === '1') return;
      img.dataset.snizeImgWatch = '1';
      img.addEventListener('error', () => repairPageImage(img));
      if (img.complete && img.naturalWidth === 0) repairPageImage(img);
    });
  }

  function observeSnizeResults(container) {
    resultsContainer = container;
    resultsObserver = new MutationObserver(() => {
      scheduleMovePaginationToTop();
      watchPageImages(container);
    });
    scheduleMovePaginationToTop();
    watchPageImages(container);
    resultsObserver.observe(container, {
      childList: true,
      subtree: true,
    });
  }

  const existingContainer = document.querySelector('.snize-search-results-content');
  if (existingContainer) {
    observeSnizeResults(existingContainer);
  } else {
    const initObserver = new MutationObserver(() => {
      const container = document.querySelector('.snize-search-results-content');
      if (container) {
        observeSnizeResults(container);
        initObserver.disconnect();
      }
    });
    initObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
});